<!-- TEMPLATE FOR MODAL DIALOG -->
<div class="modal-header bg-white">
  <div class="container-fluid modal-title">
      <div class="col-lg-11 col-md-11 col-sm-11">
          <br />
      </div>
      <div class="col-lg-1 col-md-1 col-sm-1">
          <a class="link-hover fw-light" (click)="close()"><i class="fa-regular fa-xmark fa-lg fs-4" title="Stäng"></i> Stäng</a>
      </div>
  </div>
</div>

<div class="modal-body">
  <div class="container-fluid">
      <div class="row">
          <div [innerHTML]="safeHtml"></div>
      </div>
  </div>
</div>

<div class="modal-footer">
  @if(!salesCompetitionData && salesCompetitionData.IsActive) {
      <div class="d-inline-block mt-2">
          <button (click)="openSalesCompetition()" class="btn btn-primary btn-sm salesCompetitionButton" target="_blank" [attr.title]="salesCompetitionData.AlternativeText">{{salesCompetitionData.ButtonText}}</button>
      </div>
  }
  <div class="d-inline-block"><button class="btn btn-primary" (click)="close()">Stäng</button></div>
</div>

